import { createClient } from "contentful";
const contentClient = createClient({
  accessToken: process.env.REACT_APP_CONTENT_ACCESS_TOKEN,
  space: process.env.REACT_APP_CONTENT_SPACE,
});

export default contentClient;
